var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.321,
    height: 19.321,
    viewBox: "0 0 19.321 19.321",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3888",
    d: "M0-682.665H19.321v19.321H0Z",
    transform: "translate(0 682.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g3876",
    transform: "translate(0 682.665)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3878",
    d: "M205.333-476h7.7v7.623h-7.7Z",
    transform: "translate(-199.521 -200.818)",
    fill: "none",
    stroke: "#ce7c1e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3880",
    transform: "translate(8.377 -676.816)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3882",
    d: "M0,0H2.566V2.6L1.283,1.957,0,2.6Z",
    fill: "none",
    stroke: "#ce7c1e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3884",
    transform: "translate(0 -682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3886",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3892",
    transform: "translate(8.361 0.566)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3894",
    d: "M-89.225-44.572l-1.3-1.3-1.3,1.3",
    transform: "translate(91.824 45.871)",
    fill: "none",
    stroke: "#ce7c1e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3896",
    transform: "translate(9.66 0.906)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3898",
    d: "M0,0V2.679",
    fill: "none",
    stroke: "#ce7c1e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3900",
    transform: "translate(8.361 17.454)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3902",
    d: "M0-.084l1.3,1.3,1.3-1.3",
    transform: "translate(0 0.087)",
    fill: "none",
    stroke: "#ce7c1e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3904",
    transform: "translate(9.66 15.736)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3906",
    d: "M0-91.985v-2.679",
    transform: "translate(0 94.664)",
    fill: "none",
    stroke: "#ce7c1e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3908",
    transform: "translate(17.454 8.361)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3910",
    d: "M-.084-89.224l1.3-1.3-1.3-1.3",
    transform: "translate(0.087 91.822)",
    fill: "none",
    stroke: "#ce7c1e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3912",
    transform: "translate(15.736 9.66)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3914",
    d: "M-91.985,0h-2.679",
    transform: "translate(94.664)",
    fill: "none",
    stroke: "#ce7c1e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3916",
    transform: "translate(0.566 8.361)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3918",
    d: "M-44.572,0l-1.3,1.3,1.3,1.3",
    transform: "translate(45.871)",
    fill: "none",
    stroke: "#ce7c1e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3920",
    transform: "translate(0.906 9.66)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3922",
    d: "M0,0H2.679",
    fill: "none",
    stroke: "#ce7c1e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapping);
export default __webpack_public_path__ + "static/media/mapping.6efdbb2815b5d09b322959f29440255b.svg";
export { ForwardRef as ReactComponent };